<template>
  <div class="server-detail">
    <Tabs value="baseInfoTag" @on-click="handleTabClick">
      <TabPane label="基本信息" name="baseInfoTag">
        <Card>
          <Row>
            <Col :style="{float: 'left', marginBottom: '5px'}">
              <!--<Button icon="md-return-left">返回主机列表</Button>-->
              <b :style="{marginLeft: '10px'}"><span :style="{fontSize: '18px'}"><Icon type="md-reorder" /> {{ baseInfo.hostname }}</span></b>
            </Col>
            <Col :style="{float: 'right', marginBottom: '5px'}">
              <Button icon="md-refresh" @click="refresh"></Button>
              <!-- <Button icon="md-contacts" @click="handleRedirect" type="primary" :style="{marginLeft: '10px'}">行为审计</Button> -->
              <!-- <Button icon="md-desktop" @click="handleConnect" type="primary" :style="{marginLeft: '10px'}">远程连接</Button> -->
            </Col>
          </Row>
          <Row id="server_detail_base_id">
            <Col :xs="24" :sm="24" :md="24" :lg="6">
              <Col :xs="24" :sm="24" :md="24" :lg="24" :style="{marginBottom: '10px'}">
                <Card :style="{marginBottom: '10px'}">
                  <p slot="title"><Icon type="md-pricetags" /> 基础信息</p>
                  <div id="detail_row">
                    <ul id="basic_info_id_a">
                      <li><span class="text-muted">主机名：</span><span class="text-info">{{ baseInfo.hostname }}</span></li>
                      <li><span class="text-muted">ID：</span><span class="text-info" id="info_server_id">{{ baseInfo.serverId }}</span></li>
                      <li><span class="text-muted">名称：</span><span class="text-info" id="info_name">{{ baseInfo.name }}</span></li>
                      <li><span class="text-muted">状态：</span><span class="text-info" id="info_status">{{ baseInfo.status}}</span></li>
                      <li><span class="text-muted">可用区：</span><span class="text-info" id="info_zone">{{ baseInfo.zone}}</span></li>
                      <li><span class="text-muted">操作系统类型：</span><span class="text-info" id="info_os_type">{{ baseInfo.osType}}</span></li>
                      <li><span class="text-muted">服务商：</span><span class="text-info" id="info_support">{{ baseInfo.support}}</span></li>
                      <li><span class="text-muted">自动续费：</span><span class="text-info" id="info_auto_renew">{{ baseInfo.renew}}</span></li>
                      <li><span class="text-muted">创建时间：</span><span class="text-info" id="info_create_time">{{ baseInfo.createdTime}}</span></li>
                      <li><span class="text-muted">到期时间：</span><span class="text-info" id="info_ex_time">{{ baseInfo.expiredTime}}</span></li>
                      <li><span class="text-muted">凭证：</span><span class="text-info" id="info_certificate">{{ baseInfo.certificate}}</span></li>
                      <li><span class="text-muted">备注：</span><span class="text-info" id="info_remark">{{ baseInfo.remark}}</span></li>
                    </ul>
                  </div>
                </Card>
                <Card>
                  <p slot="title"><Icon type="md-pricetags" /> 配置信息</p>
                  <ul id="config_info_id">
                    <li><span class="text-muted">CPU：</span><span class="text-info" id="info_cpu">{{ configInfo.cpu }}</span></li>
                    <li><span class="text-muted">内存：</span><span class="text-info" id="info_memory">{{ configInfo.memory }}</span></li>
                    <li><span class="text-muted">私有IP：</span><span class="text-info" id="info_inner_ip">{{ configInfo.innerIp }}</span></li>
                    <li><span class="text-muted">公网IP：</span><span class="text-info" id="info_public_ip">{{ configInfo.publicIp }}</span></li>
                    <li><span class="text-muted">操作系统：</span><span class="text-info" id="info_os">{{ configInfo.os }}</span></li>
                  </ul>
                </Card>
              </Col>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="18">
              <Col :xs="24" :sm="24" :md="24" :lg="{span: 23, offset: 1}">
                <Card :style="{marginBottom: '10px'}">
                  <p slot="title"><Icon type="md-pricetags" /> 进程信息</p>
                </Card>
                <Card :style="{marginBottom: '10px'}" id="monitorCardId">
                  <p slot="title" :style="{height: 'inherit'}">
                    <span><Icon type="md-pricetags" /> 监控信息</span>
                    <span :style="{float: 'right', fontWeight: 'normal'}">
                      <radioGroup v-model="lastTimeRadio" type="button" @on-change="getGraphData" size="small">
                        <radio label="3600">1小时</radio>
                        <radio label="21600">6小时</radio>
                        <radio label="43200">12小时</radio>
                        <radio label="86400">1天</radio>
                        <radio label="259200">3天</radio>
                        <radio label="604800">7天</radio>
                        <radio label="2592000">1月</radio>
                      </radioGroup>
                      <DatePicker
                        v-model="customTime"
                        type="datetimerange"
                        size="small"
                        style="width: 250px; margin-left: 5px"
                        format="yyyy-MM-dd HH:mm"
                        @on-ok="customTimeChange"
                        placeholder="自定义时间"
                        class="mob-w-100 mob-ml-0"></DatePicker>
                      <span style="margin-left: 10px" class="mob-ml-0">主题：</span>
                      <Select v-model="currentTheme" size="small" @on-change="saveMonitorConfig" style="width:100px; margin-left: 5px">
                        <Option v-for="item in themeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                      </Select>
                    </span>
                  </p>
                  <div v-show="loadLineShow" id="load_line" class="san_line" style="background:#fff;"></div>
                  <div id="cpu_usage_line" class="san_line" style="background:#fff;"></div>
                  <div id="memory_usage_line" class="san_line" style="background:#fff;"></div>
                  <div id="disk_usage_line" class="san_line" style="background:#fff;"></div>
                  <Row>
                    <Col :xs="24" :sm="24" :md="24" :lg="12">
                      <div id="in_net_bytes_line" class="san_line"></div>
                    </Col>
                    <Col :xs="24" :sm="24" :md="24" :lg="12">
                      <div id="out_net_bytes_line" class="san_line"></div>
                    </Col>
                  </Row>
                  <Row>
                    <Col :xs="24" :sm="24" :md="24" :lg="12">
                      <div id="in_net_packets_line" class="san_line"></div>
                    </Col>
                    <Col :xs="24" :sm="24" :md="24" :lg="12">
                      <div id="out_net_packets_line" class="san_line"></div>
                    </Col>
                  </Row>
                  <Row>
                    <Col :xs="24" :sm="24" :md="24" :lg="12">
                      <div id="disk_io_read_bytes_line" class="san_line"></div>
                    </Col>
                    <Col :xs="24" :sm="24" :md="24" :lg="12">
                      <div id="disk_io_write_bytes_line" class="san_line"></div>
                    </Col>
                  </Row>
                  <div id="disk_iops_line" class="san_line"></div>
                </Card>
              </Col>
            </Col>
          </Row>
        </Card>
      </TabPane>
      <TabPane label="磁盘信息" name="diskInfoTag">
        <Card>
          <Table
            :loading="diskTableLoading"
            :data="disk.data"
            :columns="disk.columns"></Table>
            <Row style="margin: 10px;">
              <div style="float: right;">
                <page :total="countDisk" :current="pageDisk" :page-size="sizeDisk" @on-change="getHostDiskList"></page>
              </div>
            </Row>
        </Card>
      </TabPane>
      <TabPane label="用户信息" name="userInfoTag">
        <Card>
          <!-- <Row style="margin-bottom: 10px">
            <Col :style="{float: 'right'}">
              <Button icon="md-refresh">刷新</Button>
              <Button type="primary" icon="md-add" style="margin-left: 10px">添加</Button>
            </Col>
          </Row> -->
          <Row>
            <Table
              :loading="userInfoTableLoading"
              :data="userInfo.data"
              :columns="userInfo.columns"></Table>
          </Row>
          <Row style="margin: 10px;">
            <div style="float: right;">
              <page :total="countUser" :current="pageUser" :page-size="sizeUser" @on-change="getHostUsersList"></page>
            </div>
          </Row>
        </Card>
      </TabPane>
      <TabPane label="监控数据" name="monitorInfoTag">
        <modal
          v-model="addTmpModal"
          width="600"
          scrollable
          title="添加到我的监控模板"
          @on-ok="addTmpModalOk">
          <div>
            <i-form :model="addTmpForm" ref="addTmpForm" :label-width="75" label-position="left" :rules="addTmpRule">
              <form-item label="我的模板">
                <i-select v-model="addTmpForm.myTemplate" :transfer="true" style="width: 90%">
                  <i-option v-for="item in myTemplateList" :value="item.id" :key="item.id" :label="item.name"></i-option>
                </i-select>
                <i-button type="text" @click="changeMyTemplateModal=true"><Icon type="md-add" size="15" /></i-button>
              </form-item>
            </i-form>
          </div>
        </modal>
        <modal
          v-model="changeMyTemplateModal"
          width="600"
          scrollable
          :title="changeMyTemplateModalTitle"
          @on-ok="changeMyTemplateModalOk">
          <div>
            <i-form :model="changeMyTemplateForm" ref="changeMyTemplateForm" :rules="changeMyTemplateRule" :label-width="75" label-position="left">
              <form-item label="模板名称">
                <i-input v-model="changeMyTemplateForm.name"></i-input>
              </form-item>
            </i-form>
          </div>
        </modal>
        <Modal
          footer-hide
          v-model="chartScreenModal"
          width="90%">
          <div class="title" :style="{textAlign: 'center', padding: '25px'}">
            <b><span id="chartScreenId_title" :style="{fontSize: '16px'}">{{ chartScreenIdTitle }}</span></b>
          </div>
          <div :style="{height: '500px'}" id="chartScreenId"></div>
        </Modal>
        <Card>
          <Row :style="{marginBottom: '10px'}">
            <i-switch :style="{float: 'right'}" v-model="counterTableIsShow" size="large">
              <span slot="open">隐藏</span>
              <span slot="close">显示</span>
            </i-switch>
          </Row>
          <Table
            ref="monitorTable"
            height="400"
            v-show="!counterTableIsShow"
            @on-row-click="counterRowClick"
            @on-selection-change="counterTableChange"
            border
            size="small"
            :columns="counter.columns"
            :data="counter.data"
            no-data-text="监控未启动"></Table>
          <Form :model="graphFilter" style="margin: 10px 0;" ref="graphFilter" label-position="left" inline>
            <FormItem>
              <RadioGroup v-model="graphFilter.selectTime" type="button" size="small" @on-change="monitorLastTimeChange">
                <radio label="3600">1小时</radio>
                <radio label="21600">6小时</radio>
                <radio label="43200">12小时</radio>
                <radio label="86400">1天</radio>
                <radio label="259200">3天</radio>
                <radio label="604800">7天</radio>
                <radio label="2592000">1月</radio>
              </RadioGroup>
            </FormItem>
            <FormItem>
              <DatePicker
                v-model="monitorCustomTime"
                type="datetimerange"
                style="width: 250px; margin-left: 5px"
                format="yyyy-MM-dd HH:mm"
                @on-ok="monitorCustomTimeChange"
                @on-clear="monitorCustomTimeClear"
                placeholder="自定义时间"></DatePicker>
            </FormItem>
            <FormItem>
              <Select v-model="graphFilter.angle" placeholder="Endpoint视角" style="width: 120px;" :transfer="true" @on-change="atOneGraph">
                <Option v-for="item in angle_list" :value="item.value" :key="item.value" :label="item.label"></Option>
              </Select>
            </FormItem>
            <FormItem>
              <Select v-model="graphFilter.cf" placeholder="平均值" style="width: 100px;" :transfer="true" @on-change="atOneGraph">
                <Option v-for="item in cf_list" :value="item.value" :key="item.value" :label="item.label"></Option>
              </Select>
            </FormItem>
            <FormItem label="求和" :label-width="45">
              <i-switch v-model="graphFilter.sum" @on-change="atOneGraph">
                <span slot="open">是</span>
                <span slot="close">否</span>
              </i-switch>
            </FormItem>
            <FormItem label="只求和" :label-width="60">
              <i-switch v-model="graphFilter.sumonly" @on-change="atOneGraph">
                <span slot="open">是</span>
                <span slot="close">否</span>
              </i-switch>
            </FormItem>
            <FormItem>
              <Button @click="drawGraph" type="primary" v-show="!counterTableIsShow">生成图表</Button>
              <Button @click="addTmpModalShow" type="primary" style="margin-left: 5px;">添加到我的监控模板</Button>
            </FormItem>
          </Form>
          <div id="monitor_card">
            <div v-for="item in monitorData" v-bind:key="item.id">
              <Col :span="monitorColSpan" :style="{marginBottom: '10px'}">
                <Col span="23">
                  <Card>
                    <p slot="title">
                      <span :id="'graph_id_' + item.id + '_title'">{{ item.title }}</span>
                      <span :style="{float : 'right'}">
                    <Button type="text" @click="chartScreen(item)" size="small">
                      <Icon type="md-expand" size="16" />
                    </Button>
                  </span>
                    </p>
                    <div :id="'graph_id_' + item.id" :style="graphDivStyle"></div>
                  </Card>
                </Col>
              </Col>
            </div>
          </div>
        </Card>
      </TabPane>
      <TabPane label="修改记录" name="operationRecordTag">
        <Logs :logs="RevisionLogs" />
      </TabPane>
      <TabPane label="行为审计" name="SpringBoardLogs">
        <SpringBoardLogs ref="SpringBoardLogs" :ip="configInfo.innerIp"/>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import { detailOpsCenterServer, getContentTypeId, getRevisionLogs, getHostDiskList, getHostUsersList, getConnectId, getUserHostPerm } from '@/api/opscenter'
import { getEndpointMonitorData, getMonitorConfig, changeMonitorConfig, getCounterList, getEndpoints,
  postTmpGraph, getAllPersonalTmpList, ChangePersonalTmp } from '@/api/monitor'
import { ClientIdentifier } from '@/libs/clientIdentifier'
import Logs from './Logs'
import SpringBoardLogs from '../springboard/SpringBoardLogs'
import echarts from '../monitor/components/echarts-use.js'
import { valueTranUnit } from '@/libs/tools'
import config from '@/config'

const guacamoleUrl = config.guacamoleUrl
let option = {
  title: {
    text: ''
  },
  grid: {
    x: 40,
    x2: 40,
    left: 60
  },
  toolbox: {
    show: true,
    feature: {
      dataZoom: {
        yAxisIndex: 'none'
      },
      dataView: {readOnly: false},
      magicType: {type: ['line', 'bar']},
      restore: {},
      saveAsImage: {}
    }
  },
  tooltip: {
    trigger: 'axis',
    formatter: function (params) {
      let str = '<div>' + params[0].axisValueLabel + '</div>'
      for (let i = 0; i < params.length; i++) {
        let value = params[i].data[1]
        let reValue = valueTranUnit(value, 1, '')
        str += '<div class="circle_tooltip" style="background-color: ' + params[i].color + '"></div>' +
          '<span>' + params[i].seriesName + '</span> : <span>' + (value !== null ? reValue : '无数据') + '</span><br/>'
      }
      return str
    }
  },
  // tooltip: {
  //   trigger: 'axis',
  //   formatter: function (params) {
  //     let str = '<div>' + params[0].axisValueLabel + '</div>'
  //     for (let i = 0; i < params.length; i++) {
  //       let value = params[i].data[1]
  //       let unit = ''
  //       if (value >= 1024 * 1024 * 1024) {
  //         value = (value / (1024 * 1024 * 1024)).toFixed(1)
  //         unit = ' (GB)'
  //       } else if (value >= 1024 * 1024) {
  //         value = (value / (1024 * 1024)).toFixed(1)
  //         unit = ' (MB)'
  //       } else if (value >= 1024) {
  //         value = (value / 1024).toFixed(1)
  //         unit = ' (kB)'
  //       }
  //       let reValue = value + unit
  //
  //       str += '<div class="circle_tooltip" style="background-color: ' + params[i].color + '"></div>' +
  //         '<span>' + params[i].seriesName + '</span> : <span>' + (value !== null ? reValue : '无数据') + '</span><br/>'
  //     }
  //     return str
  //   }
  // },
  legend: {
    x: 'center',
    y: 'bottom',
    type: 'scroll',
    width: '90%',
    icon: 'rect',
    itemWidth: 10,
    itemHeight: 10,
    itemGap: 15
  },
  xAxis: {
    type: 'time',
    splitLine: {
      show: true
    }
  },
  yAxis: {
    type: 'value',
    splitLine: {
      show: true
    },
    axisLabel: {
      formatter: function (value) {
        return valueTranUnit(value, 0)
      }
    }
    // axisLabel: {
    //   formatter: function (value, index) {
    //     let unit = ''
    //     let isAbs = ''
    //     if (value < 0) {
    //       isAbs = '-'
    //       value = Math.abs(value)
    //     }
    //     if (value >= 1024 * 1024 * 1024) {
    //       value = (value / (1024 * 1024 * 1024)).toFixed(0)
    //       unit = ' GB'
    //     } else if (value >= 1024 * 1024) {
    //       value = (value / (1024 * 1024)).toFixed(0)
    //       unit = ' MB'
    //     } else if (value >= 1024) {
    //       value = (value / 1024).toFixed(0)
    //       unit = ' kB'
    //     }
    //     return isAbs + value + unit
    //   }
    // }
  },
  series: []
}

export default {
  name: 'server-detail',
  components: {
    'Logs': Logs,
    'SpringBoardLogs': SpringBoardLogs
  },
  data () {
    return {
      userPermDetail: [],
      systemUsersAll: [],
      systemUsersSel: '',
      systemUserKeySel: '',
      conProtocolType: '',
      defaultIp: 'public',
      defaultSelIp: null,
      diskTableLoading: false,
      pageDisk: 1,
      countDisk: 1,
      sizeDisk: 10,
      pageUser: 1,
      countUser: 1,
      sizeUser: 10,
      currentTheme: 'dark',
      monitorTheme: 'dark',
      themeList: [
        {label: 'dark', value: 'dark'},
        {label: 'roma', value: 'roma'},
        {label: 'shine', value: 'shine'},
        {label: 'vintage', value: 'vintage'},
        {label: 'macarons', value: 'macarons'},
        {label: 'infographic', value: 'infographic'},
        {label: 'darkPro', value: 'darkPro'},
        {label: 'dark-line', value: 'dark-line'},
        {label: 'roma-line', value: 'roma-line'},
        {label: 'shine-line', value: 'shine-line'},
        {label: 'vintage-line', value: 'vintage-line'},
        {label: 'macarons-line', value: 'macarons-line'},
        {label: 'infographic-line', value: 'infographic-line'},
        {label: 'darkPro-line', value: 'darkPro-line'}
      ],
      disk: {
        data: [],
        columns: [
          {
            title: '挂载点',
            key: 'disk_mount',
            minWidth: 80,
            align: 'center'
          },
          {
            title: '源设备',
            key: 'disk_source',
            minWidth: 80,
            align: 'center'
          },
          {
            title: '总大小',
            key: 'disk_capacity',
            minWidth: 80,
            align: 'center'
          },
          {
            title: '已使用',
            key: 'disk_used',
            minWidth: 80,
            align: 'center'
          },
          {
            title: '可用',
            key: 'disk_available',
            minWidth: 80,
            align: 'center'
          },
          {
            title: '使用百分比',
            key: 'disk_usage',
            minWidth: 100,
            align: 'center'
          }
        ]
      },
      userInfoTableLoading: false,
      lastTimeRadio: '3600',
      userInfo: {
        data: [],
        columns: [
          {
            title: 'ID',
            key: 'user_id',
            minWidth: 60,
            align: 'center'
          },
          {
            title: '用户',
            key: 'user_name',
            minWidth: 80,
            align: 'center'
          },
          {
            title: 'UID',
            key: 'user_uid',
            minWidth: 80,
            align: 'center'
          },
          {
            title: 'shell',
            key: 'user_shell',
            minWidth: 80,
            align: 'center'
          },
          {
            title: '家目录',
            key: 'user_home',
            minWidth: 80,
            align: 'center'
          },
          {
            title: '所属组',
            key: 'user_groups',
            minWidth: 80,
            align: 'center'
          },
          {
            title: '上次修改密码时间',
            key: 'user_password_modify_time',
            minWidth: 150,
            align: 'center'
          },
          {
            title: '密码过期时间',
            key: 'user_password_expires_time',
            minWidth: 120,
            align: 'center'
          },
          {
            title: '账号过期时间',
            key: 'user_expires_time',
            minWidth: 120,
            align: 'center'
          },
          {
            title: '用户状态',
            key: 'user_active_state',
            minWidth: 100,
            align: 'center'
          }
        ]
      },
      baseInfo: {
        hostname: '',
        serverId: '',
        name: '',
        status: '',
        zone: '',
        osType: '',
        os: '',
        support: '',
        renew: '',
        createdTime: '',
        expiredTime: '',
        certificate: '',
        remark: ''
      },
      configInfo: {
        cpu: '',
        memory: '',
        innerIp: '',
        publicIp: '',
        os: ''
      },
      customTime: '',
      loadLineShow: false,
      contentTypeId: '',
      RevisionLogs: [],

      // 监控
      endpointId: '',
      counterTableIsShow: false,
      counter: {
        columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: 'Counter',
            key: 'counter'
          },
          {
            title: '类型',
            key: 'type',
            render: (h, params) => {
              const row = params.row
              const res = row.type === 'GAUGE' ? '原始值' : row.type === 'DERIVE' ? '计数器' : row.type
              return h('span', res)
            }
          },
          {
            title: '频率(秒)',
            key: 'step'
          }
        ],
        data: []
      },
      counter_selected_list: [],
      graphFilter: {
        angle: 'endpoint',
        cf: 'AVERAGE',
        sum: false,
        sumonly: false,
        selectTime: '3600',
        start: '',
        end: ''
      },
      monitorCustomTime: '',
      angle_list: [
        {
          value: 'endpoint',
          label: 'Endpoint视角'
        },
        {
          value: 'counter',
          label: 'Counter视角'
        },
        {
          value: 'merge',
          label: '组合视角'
        }
      ],
      cf_list: [
        {
          value: 'AVERAGE',
          label: '平均值'
        },
        {
          value: 'MAX',
          label: '最大值'
        },
        {
          value: 'MIN',
          label: '最小值'
        }
      ],
      monitorData: [],
      monitorColSpan: 12,
      graphDivStyle: {
        height: '300px'
      },
      monitorIndex: 0,

      addTmpModal: false,
      addTmpForm: {
        myTemplate: ''
      },
      addTmpRule: {
        myTemplate: [
          {required: true, message: '请选择一个模板', trigger: 'blur'}
        ]
      },
      myTemplateList: [],

      changeMyTemplateModal: false,
      changeMyTemplateModalTitle: '新建一个模板',
      changeMyTemplateForm: {
        id: 0,
        name: ''
      },
      changeMyTemplateRule: {
        name: [
          {required: true, message: '模板名称是必填的', trigger: 'blur'}
        ]
      },

      chartScreenModal: false,
      chartScreenIdTitle: ''
    }
  },
  mounted: function () {
    this.init()
  },
  watch: {
    '$route' (to, from) {
      if (this.$route.query.id) {
        this.init()
      }
    }
  },
  methods: {
    init () {
      this.getTheme()
      getContentTypeId({'model_name': 'Server'}).then(res => {
        let result = res.data
        this.contentTypeId = result.content_type_id
        this.revisionLog()
        this.getMyTemplateList()
      })
    },
    handleTabClick (value) {
      if (value === 'diskInfoTag') {
        this.getHostDiskList()
      } else if (value === 'userInfoTag') {
        this.getHostUsersList()
      } else if (value === 'SpringBoardLogs') {
        this.$refs.SpringBoardLogs.getSpringBoradLogList()
      }
    },
    getHostDiskList (value = 1) {
      this.pageDisk = value
      let params = {
        page: this.pageDisk
      }
      getHostDiskList(this.$route.query.id, params).then(res => {
        this.disk.data = res.data
        this.countDisk = res.data.count
      })
    },
    getHostUsersList (value = 1) {
      this.pageUser = value
      let params = {
        page: this.pageUser
      }
      getHostUsersList(this.$route.query.id, params).then(res => {
        this.userInfo.data = res.data
        this.countUser = res.data.count
      })
    },
    refresh () {
      this.getDetailInfo()
      this.getGraphData()
    },
    getDetailInfo () {
      detailOpsCenterServer(this.$route.query.id).then(res => {
        let result = res.data
        let myOsType = {0: 'Linux', 1: 'Windows'}
        this.baseInfo.hostname = result.hostname
        this.baseInfo.serverId = result.server_id
        this.baseInfo.name = result.name
        this.baseInfo.status = result.status
        this.baseInfo.osType = myOsType[result.os]
        this.baseInfo.os = result.os
        this.baseInfo.remark = result.remark
        this.configInfo.innerIp = result.inner_ip
        this.configInfo.publicIp = result.public_ip
        if (result.certificate) {
          this.baseInfo.certificate = result.certificate.name
        }
        if (result.support) {
          this.baseInfo.support = result.support.name
        }
        let serverInfo = result.server_info_format
        if (serverInfo['可用区']) {
          this.baseInfo.zone = serverInfo['可用区']
        }
        if (serverInfo['创建时间']) {
          this.baseInfo.createdTime = serverInfo['创建时间']
        }
        if (serverInfo['到期时间']) {
          this.baseInfo.expiredTime = serverInfo['到期时间']
        }
        if (serverInfo['CPU']) {
          this.configInfo.cpu = serverInfo['CPU']
        }
        if (serverInfo['内存']) {
          this.configInfo.memory = serverInfo['内存']
        }
        if (serverInfo['操作系统']) {
          this.baseInfo.os = serverInfo['操作系统']
        }
        this.getGraphData()
        this.getCounters()
      }).catch(res => {
        this.$Notice.error({
          title: '获取主机信息失败！'
        })
      })
    },
    getGraphData (lastTime = this.lastTimeRadio, startTime = '', endTime = '') {
      if (!startTime || !endTime) {
        this.customTime = ''
      }
      let hostname = this.baseInfo.hostname
      let counterAndId = {
        'cpu.user': 'cpu_usage_line',
        'mem.memused.percent': 'memory_usage_line',
        'df.statistics.used.percent': 'disk_usage_line',
        'net.if.in.bytes.total': 'in_net_bytes_line',
        'net.if.out.bytes.total': 'out_net_bytes_line',
        'net.if.in.packets.total': 'in_net_packets_line',
        'net.if.out.packets.total': 'out_net_packets_line',
        'disk.io.read_bytes.total': 'disk_io_read_bytes_line',
        'disk.io.write_bytes.total': 'disk_io_write_bytes_line',
        'disk.iops': 'disk_iops_line'
      }
      if (this.baseInfo.osType === 'Linux') {
        this.loadLineShow = true
        counterAndId['load.1min'] = 'load_line'
        counterAndId['load.5min'] = 'load_line'
        counterAndId['load.15min'] = 'load_line'
      } else {
        this.loadLineShow = false
      }
      let loadSeries = []
      for (let x in counterAndId) {
        let reqData = {
          'endpoints': [hostname],
          'counters': [x],
          'last': lastTime,
          'start': startTime,
          'end': endTime,
          'angle': 'counter',
          'cf': 'AVERAGE',
          'sum': false,
          'sumonly': false
        }
        let elem = $('#' + counterAndId[x])
        elem.css('height', '300px')
        elem.css('line-height', '')
        elem.css('text-align', '')
        getEndpointMonitorData(reqData).then(res => {
          let generate = 0
          let result = res.data
          if (result.code === 200) {
            let data = result.data.series
            if (data.length > 0) {
              let dseries = []
              let haveArea = false
              let monitorTheme = this.monitorTheme
              if (monitorTheme.endsWith('-line')) {
                monitorTheme = monitorTheme.split('-line')[0]
              } else {
                haveArea = true
              }
              for (let v in data) {
                let dseriesData = []
                if (x === 'load.1min' || x === 'load.5min' || x === 'load.15min') {
                  let dSeriesConfig = {
                    name: data[v].name,
                    data: data[v].data,
                    type: 'line',
                    symbolSize: 0,
                    itemStyle: {
                      normal: {
                        lineStyle: {
                          width: 1
                        }
                      }
                    }
                  }
                  if (haveArea) {
                    dSeriesConfig.areaStyle = {
                      opacity: 0.2
                    }
                  }
                  loadSeries.push(dSeriesConfig)
                  if (loadSeries.length === 3) {
                    dseries = loadSeries
                    loadSeries = []
                    generate = 1
                  }
                } else {
                  dseriesData = {
                    name: data[v].name,
                    data: data[v].data,
                    type: 'line',
                    symbolSize: 0,
                    itemStyle: {
                      normal: {
                        lineStyle: {
                          width: 1
                        }
                      }
                    }
                  }
                  if (haveArea) {
                    dseriesData.areaStyle = {
                      opacity: 0.2
                    }
                  }
                  generate = 1
                  dseries.push(dseriesData)
                }
              }
              if (generate === 1) {
                option.series = dseries
                let graphLine = echarts.init(document.getElementById(counterAndId[x]), monitorTheme)
                window.addEventListener('resize', function () {
                  graphLine.resize()
                })
                graphLine.clear()
                graphLine.setOption(option, true)
              }
            } else {
              elem.css('height', '50px')
              elem.css('line-height', '50px')
              elem.css('text-align', 'center')
              elem.html('<span style="font-size: 15px;">' + x + ' 无数据</span>')
            }
          } else {
            elem.css('height', '50px')
            elem.css('line-height', '50px')
            elem.css('text-align', 'center')
            elem.html('<span style="font-size: 15px;">' + x + ' 无数据</span>')
            this.$Notice.error({
              title: '获取监控数据失败！',
              desc: result.msg
            })
          }
        }).catch(res => {
          elem.css('height', '50px')
          elem.css('line-height', '50px')
          elem.css('text-align', 'center')
          elem.html('<span style="font-size: 15px;">' + x + ' 无数据</span>')
          if (res.request) {
            this.$Notice.error({
              title: '获取监控数据失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          }
        })
      }
    },
    saveMonitorConfig (theme) {
      if (this.monitorTheme === theme) {
        return false
      }
      this.monitorTheme = theme
      let reqData = {'theme': theme}
      changeMonitorConfig(reqData).then(res => {
        let result = res.data
        if (result.code === 200) {
          window.location.reload()
        }
      })
    },
    revisionLog () {
      let params = {
        object_id: this.$route.query.id,
        content_type: this.contentTypeId
      }
      getRevisionLogs(params).then(res => {
        this.RevisionLogs = res.data
      })
    },
    getTheme () {
      getMonitorConfig().then(res => {
        let result = res.data
        if (result.code === 200) {
          this.monitorTheme = result.data.theme
          this.currentTheme = result.data.theme
          this.getDetailInfo()
        }
      }).catch(res => {
        this.getDetailInfo()
      })
    },
    customTimeChange () {
      let timeRange = [this.customTime[0].getTime() / 1000, this.customTime[1].getTime() / 1000]
      if (timeRange[0] && timeRange[1]) {
        this.lastTimeRadio = ''
        this.getGraphData('3600', timeRange[0], timeRange[1])
      }
    },
    // 跳转到跳板机日志
    handleRedirect () {
      this.$router.push({name: 'SpringBoardMain', query: {index: 3}})
    },
    connetRemoteAsset (ip) {
      // 调用后台创建 guacamole connect ，将返回id直接传到下面url中，连接远程机器，无需管 ops和 guacamole数据同步，目的是连接远程机器，权限在ops这边控制
      // let name = this.systemUsersSel
      let data = {
        ip: ip,
        username: this.systemUsersSel,
        key: this.systemUserKeySel,
        os: this.baseInfo.os,
        keyType: this.conProtocolType
      }
      getConnectId(data).then(res => {
        if (res.status === 200) {
          let connectId = ClientIdentifier(parseInt(res.data))
          // window.location.href = 'http://opsdeep.aukeyit.com/guacamole/#/client/' + connectId
          // let url = 'http://10.1.2.127:8080/guacamole/#/client/' + connectId
          let url = guacamoleUrl + '/guacamole/#/client/' + connectId
          let h = window.screen.availHeight
          let w = window.screen.availWidth
          window.open(url, '堡垒机', 'left=0,top=0,width=' + w + ',height=' + h + ',directories=no,location=no,toolbar=no,menubar=no,status=no,scrollbars=no,titlebar=no,resizable=no')
        } else {
          this.$Message.error('获取连接信息失败，请核查数据')
        }
      })
    },
    // 远程连接
    handleConnect () {
      // 先判断用户是否有权限连接当前这台主机
      // let paramsPerm = {
      //   username: this.$store.state.user.userName
      // }
      getUserHostPerm().then(res => {
        let canCon
        this.userPermDetail = res.data.map(item => item[0])
        let sysUsers = res.data.filter(item => item[0] === parseInt(this.$route.query.id))
        if (this.userPermDetail.indexOf(Number(this.$route.query.id)) > -1) {
          canCon = true
        } else {
          canCon = false
        }
        if (!canCon) {
          this.$Modal.error({
            title: '无操作权限',
            content: '您没有该主机的连接权限，请联系管理员开通 ！'
          })
        } else {
          // 弹出系统用户选择框
          if (sysUsers) {
            this.systemUsersAll = sysUsers.map(item => item[1])
            this.systemUsersSel = this.systemUsersAll[0]
            this.systemUserKeySel = sysUsers.filter(item => item[1] === this.systemUsersSel).map(item => item[2])[0]
            this.conProtocolType = sysUsers.filter(item => item[1] === this.systemUsersSel).map(item => item[3])[0]
          } else {
            this.$Message.error('系统异常，取不到当前用户，当前主机所对应的系统用户，请检查权限数据')
          }
          // 判断公网ip 私有ip 给defaultIp 赋值
          if (this.configInfo.publicIp || this.configInfo.innerIp) {
            this.defaultIp = this.configInfo.publicIp ? 'public' : 'private'
            this.defaultSelIp = this.configInfo.publicIp ? this.configInfo.publicIp : this.configInfo.innerIp
          } else {
            this.$Message.error('系统异常，公有IP,私有IP都为空,请检查凭证ip数据')
            return
          }
          this.$Modal.info({
            width: '500px',
            title: '远程连接',
            onOk: () => {
              if (this.defaultSelIp) {
                this.connetRemoteAsset(this.defaultSelIp)
              } else {
                this.$Message.error('ip为空，不能建立连接,请检查凭证ip数据')
              }
            },
            render: (h) => {
              return h('div', [
                h('Divider'),
                h('span', {style: {color: '#515a6e'}}, '连接IP：'),
                h('RadioGroup', {
                  props: {
                    type: 'button',
                    value: this.defaultIp
                  },
                  style: {marginLeft: '58px'},
                  on: {
                    'on-change': (val) => {
                      if (val === 'private') {
                        this.defaultSelIp = ''
                        if (this.configInfo.innerIp) {
                          this.defaultSelIp = this.configInfo.innerIp
                        } else {
                          this.$Message.error('内部ip为空，不能建立连接')
                        }
                      } else {
                        this.defaultSelIp = ''
                        if (this.configInfo.publicIp) {
                          this.defaultSelIp = this.configInfo.publicIp
                        } else {
                          this.$Message.error('外部ip为空，不能建立连接')
                        }
                      }
                    }
                  }
                }, [
                  h('Radio', {
                    props: {
                      label: 'private'
                    }}, '内部IP'),
                  h('Radio', {
                    props: {
                      label: 'public'
                    }}, '外部IP')
                ]),
                h('br'),
                h('br'),
                h('span', {style: {color: '#515a6e'}}, '请选择凭证用户：'),
                h('Select', {
                  props: {
                    value: this.systemUsersSel
                  },
                  on: {
                    'on-change': (value) => {
                      this.systemUsersSel = value
                      this.systemUserKeySel = sysUsers.filter(item => item[1] === this.systemUsersSel).map(item => item[2])[0]
                    }
                  },
                  style: {
                    width: '200px'
                  }
                },
                this.systemUsersAll.map(function (item) {
                  return h('Option', {
                    props: {value: item}
                  }, item)
                })
                ),
                h('Divider')
              ])
            }
            // render: (h) => {
            //   return h('div', [
            //     h('span', {style: {color: '#515a6e'}}, '请选择凭证用户：'),
            //     h('Select', {
            //       props: {
            //         value: this.systemUsersSel
            //       },
            //       on: {
            //         'on-change': (value) => {
            //           this.systemUsersSel = value
            //           this.systemUserKeySel = sysUsers.filter(item => item[1] === this.systemUsersSel).map(item => item[2])[0]
            //           console.log(this.systemUserKeySel + '  111')
            //         }
            //       },
            //       style: {
            //         width: '200px'
            //       }
            //     },
            //     this.systemUsersAll.map(function (item) {
            //       return h('Option', {
            //         props: {value: item}
            //       }, item)
            //     })
            //     )
            //   ])
            // }
          })
        }
      })
    },
    // 监控数据
    drawGraph () {
      this.monitorData = []
      if (this.counter_selected_list.length <= 0) {
        this.$Notice.error({title: '请至少选择1个Counter'})
      } else {
        this.counterTableIsShow = true
        if (this.graphFilter.angle === 'endpoint') {
          if (this.counter_selected_list.length === 1) {
            this.monitorColSpan = 24
            this.graphDivStyle.height = '500px'
          } else {
            this.monitorColSpan = 12
            this.graphDivStyle.height = '300px'
          }
          for (let v in this.counter_selected_list) {
            let reqData = {
              'endpoints': [this.baseInfo.hostname],
              'last': this.graphFilter.selectTime,
              'angle': this.graphFilter.angle,
              'cf': this.graphFilter.cf,
              'sum': this.graphFilter.sum,
              'sumonly': this.graphFilter.sumonly,
              'start': this.graphFilter.start,
              'end': this.graphFilter.end
            }
            let titleT = this.counter_selected_list[v]
            reqData.counters = [titleT]
            this.monitorIndex++
            reqData.id = this.monitorIndex
            reqData.title = titleT
            this.monitorData.push(reqData)
            this.getMonitorGraphData(reqData, 'graph_id_' + this.monitorIndex)
          }
        } else {
          this.monitorColSpan = 24
          this.graphDivStyle.height = '500px'
          let reqData = {
            'endpoints': [this.baseInfo.hostname],
            'counters': this.counter_selected_list,
            'last': this.graphFilter.selectTime,
            'angle': this.graphFilter.angle,
            'cf': this.graphFilter.cf,
            'sum': this.graphFilter.sum,
            'sumonly': this.graphFilter.sumonly,
            'start': this.graphFilter.start,
            'end': this.graphFilter.end
          }
          this.monitorIndex++
          reqData.id = this.monitorIndex
          reqData.title = this.baseInfo.hostname
          this.monitorData.push(reqData)
          this.getMonitorGraphData(reqData, 'graph_id_' + this.monitorIndex)
        }
      }
    },
    getMonitorGraphData (reqData, graphId) {
      getEndpointMonitorData(reqData).then(res => {
        let result = res.data
        if (result.code === 200) {
          let data = result.data.series
          document.getElementById(graphId + '_title').innerHTML = result.data.title
          let dseries = []
          let haveArea = false
          let monitorTheme = this.monitorTheme
          if (monitorTheme.endsWith('-line')) {
            monitorTheme = monitorTheme.split('-line')[0]
          } else {
            haveArea = true
          }
          for (let v in data) {
            let dSeriesConfig = {
              name: data[v].name,
              data: data[v].data,
              type: 'line',
              symbolSize: 0,
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 1
                  }
                }
              }
            }
            if (haveArea) {
              dSeriesConfig.areaStyle = {
                opacity: 0.2
              }
            }
            dseries.push(dSeriesConfig)
          }
          option.series = dseries
          let graphLine = echarts.init(document.getElementById(graphId), monitorTheme)
          window.addEventListener('resize', function () {
            graphLine.resize()
          })
          graphLine.clear()
          graphLine.setOption(option, true)
        } else {
          this.$Notice.error({
            title: '获取监控数据失败！',
            desc: result.msg
          })
        }
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '获取监控数据失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          that.$Notice.error({
            title: '获取监控数据失败'
          })
        }
      })
    },
    addTmpModalShow () {
      let that = this
      if (that.counter_selected_list.length <= 0) {
        that.monitorCardIsShow = false
        this.$Notice.error({title: '请至少选择1个Counter'})
        return
      }
      this.addTmpModal = true
    },
    atOneGraph () {
      if (this.counterTableIsShow) {
        this.drawGraph()
      }
    },
    monitorCustomTimeChange () {
      let timeRange = [this.monitorCustomTime[0].getTime() / 1000, this.monitorCustomTime[1].getTime() / 1000]
      if (timeRange[0] && timeRange[1]) {
        this.graphFilter.selectTime = ''
        this.graphFilter.start = timeRange[0]
        this.graphFilter.end = timeRange[1]
      } else {
        this.graphFilter.selectTime = '3600'
        this.graphFilter.start = ''
        this.graphFilter.end = ''
      }
      this.atOneGraph()
    },
    monitorCustomTimeClear () {
      this.graphFilter.start = ''
      this.graphFilter.end = ''
      this.graphFilter.selectTime = '3600'
      this.atOneGraph()
    },
    counterRowClick (data, index) {
      let that = this
      that.$refs.monitorTable.objData[index]._isChecked = !that.$refs.monitorTable.objData[index]._isChecked
      if (that.$refs.monitorTable.objData[index]._isChecked) {
        that.counter_selected_list.push(data.counter)
      } else {
        that.counter_selected_list = []
        for (let i in that.$refs.monitorTable.objData) {
          if (that.$refs.monitorTable.objData[i]._isChecked) {
            that.counter_selected_list.push(that.$refs.monitorTable.objData[i].counter)
          }
        }
      }
    },
    counterTableChange (data) {
      let that = this
      that.counter_selected_list = []
      for (let i in data) {
        that.counter_selected_list.push(data[i].counter)
      }
    },
    monitorLastTimeChange () {
      this.monitorCustomTime = ''
      this.graphFilter.start = ''
      this.graphFilter.end = ''
      this.atOneGraph()
    },
    getCounters () {
      getEndpoints({q: this.baseInfo.hostname}).then(res => {
        let result = res.data
        if (result.code === 200) {
          for (let i in result.data) {
            if (result.data[i].endpoint === this.baseInfo.hostname) {
              let reqData = {
                'eid': result.data[i].id,
                'limit': 0
              }
              getCounterList(reqData).then(res => {
                let resultData = res.data
                if (resultData.code === 200) {
                  this.counter.data = resultData.data
                } else {
                  this.$Notice.error({
                    title: '获取监控指标列表失败！',
                    desc: '请求状态码:' + resultData.code + ', ' + resultData.msg
                  })
                }
              }).catch(res => {
                this.counter.data = []
                if (res.request) {
                  this.$Notice.error({
                    title: '获取监控指标列表失败！',
                    desc: '请求状态码:' + res.request.status + ', ' + res.request.responseText
                  })
                }
              })
              break
            }
          }
        }
      }).catch(res => {})
    },
    addTmpModalOk () {
      let that = this
      if (!that.graphFilter.selectTime) {
        this.$Notice.error({title: '加入模板不能选择自定义时间！'})
        return false
      }
      let reqData = {
        'tmp': that.addTmpForm.myTemplate,
        'endpoints': [this.baseInfo.hostname],
        'counters': that.counter_selected_list,
        'last': that.graphFilter.selectTime,
        'angle': that.graphFilter.angle,
        'cf': that.graphFilter.cf,
        'sum': that.graphFilter.sum,
        'sumonly': that.graphFilter.sumonly
      }
      postTmpGraph(reqData).then(res => {
        that.addTmpForm.myTemplate = ''
        that.$Notice.success({title: '操作成功！'})
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    changeMyTemplateModalOk () {
      let that = this
      let reqData = that.changeMyTemplateForm
      ChangePersonalTmp(reqData, that.changeMyTemplateForm.id).then(res => {
        that.changeMyTemplateModal = false
        that.getMyTemplateList()
        that.changeMyTemplateForm.id = 0
        that.changeMyTemplateForm.name = ''
        that.$Notice.success({
          title: '操作成功！'
        })
      }).catch(res => {
        that.$Notice.error({
          title: '操作失败！请求状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    getMyTemplateList () {
      let that = this
      getAllPersonalTmpList().then(res => {
        that.myTemplateList = res.data
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    chartScreen (data) {
      this.chartScreenModal = true
      this.graphFilter = data
      this.graphFilter.selectTime = data.last + ''
      this.chartScreenIdTitle = data.title
      this.getMonitorGraphData(data, 'chartScreenId')
    }
  }
}
</script>

<style>
  #basic_info_id_a li, #config_info_id li {
    list-style-type:none;
    padding: 8px 20px 8px 10px;
    border-bottom:1px dashed rgb(238, 238, 238);
  }
  #detail_row .text-muted {
    margin-left: 10px;
  }
  #detail_row .text-info{
    float: right;
    font-size: 13px;
    color: #333333;
  }
  .server-detail  .ivu-card-body {
    padding: 5px 10px;
  }
  #server_detail_base_id .ivu-card-head {
    /*height: 45px;*/
    border-left: 4px solid #6d7781;
    background-color: #F5F6FA;
  }
  .san_line {
    height: 300px
  }
  #monitorCardId .ivu-card-body {
    padding: 0;
  }
  #monitor_card .ivu-card-body {
    padding: 0;
  }
  #monitor_card .ivu-card-head {
    background-color: #F2F2F2;
    height: 30px;
    padding:0;
  }
  #monitor_card .ivu-card-head p {
    padding-left: 10px;
    height: 30px;
    line-height: 30px;
    text-align:center;
  }
  .server-detail .ivu-card-head p{
    text-overflow: unset;
    white-space: unset;
  }
  @media screen and (max-width:640px){
    .server-detail .ivu-card-head{
      padding: 14px 10px;
    }
    .ivu-radio-group-button.ivu-radio-group-small .ivu-radio-wrapper{
      padding:0 10px;
    }
    .mob-w-100.mob-ml-0{
      margin-top:5px;
      margin-bottom:5px;
    }
  }
</style>
